export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/raceid/',
  instagram: 'https://www.instagram.com/raceid/',
  linkedin: 'https://www.linkedin.com/company/raceid/',
};
